@if (beneficiary) {
  <div class="row full-height">
    @if (id !== 0) {
      <div class="col-12 col-lg-3">
        <app-beneficiary-summary [beneficiary]="beneficiary" page="beneficiaryDetailPage"></app-beneficiary-summary>
      </div>
    }
    <div [class]="'col-12 border-start bg-white px-0 ' + (id !== 0 ? 'col-lg-9' : 'col-lg-12')">
      @if (id !== 0) {
        <ul class="nav-tabs nav-fill" (navChange)="onNavChange($event)" ngbNav #nav="ngbNav" [(activeId)]="activeTabId">
          <li [ngbNavItem]="'personaldata'">
            <a ngbNavLink><h5 class="text-secondary">État civil</h5></a>
          </li>
          <li [ngbNavItem]="'complement'" [disabled]="id === 0" *appOnlyGroups="['ADMIN', 'STRUCTURE', 'TERRITORY', 'DIRECTION', 'DIRECTION+', 'MMIE']">
            <a ngbNavLink><h5 class="text-secondary">Complément</h5></a>
          </li>
          <li [ngbNavItem]="'employment'" [disabled]="id === 0" *appOnlyGroups="['ADMIN', 'STRUCTURE', 'TERRITORY', 'DIRECTION', 'DIRECTION+', 'MMIE']">
            <a ngbNavLink><h5 class="text-secondary">Emploi</h5></a>
          </li>
          <li [ngbNavItem]="'documents'" [disabled]="id === 0" *appOnlyGroups="['ADMIN', 'STRUCTURE', 'TERRITORY', 'DIRECTION', 'DIRECTION+', 'MMIE']">
            <a ngbNavLink><h5 class="text-secondary" id="documentsTitle">Documents</h5></a>
          </li>
        </ul>
      }
      <router-outlet></router-outlet>
    </div>
  </div>
}
